/**
 * This file contains the interfaces for Gateway definition structure. GatewayDefinition is a GENERIC structure that contains
 * information about a gateway.
 * A Gateway type is a MODE's DeviceClass. We need a way to store metadata for Gateway types but the problem with a DeviceClass is
 * that it has only has 2 properties, id and description. Therefore, Gateway types will have a separate structure call GatewayDefinition
 * which contains all the information about a gateway and how it is configured.
 */
/**
 * Each gateway config prop can be one of these type.
 */
export var ConfigParamType;
(function (ConfigParamType) {
    ConfigParamType["STRING"] = "string";
    ConfigParamType["NUMBER"] = "number";
    ConfigParamType["BOOLEAN"] = "boolean";
})(ConfigParamType || (ConfigParamType = {}));
/**
 * Type guard to check if a config object is a GatewayConfig
 * @param config
 */
export const isGatewayConfig = (config) => {
    return config !== undefined && typeof config === 'object';
};
